module.exports = __webpack_public_path__ + "img/main_bg_deco_002.af023c7.webp";